var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"big-btn"},[_c('el-row',[_c('div',{staticClass:"icon-position"},[_c('i',{class:_vm.iconBtn})])]),_c('el-row',[_c('div',[_c('p',[_vm._v(_vm._s(_vm._f("upper")(_vm.msg)))])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }